<template>
  <div id="page-panel">
    <resize-observer @notify="__resizeHanlder" />
    <el-tabs v-model="activeName">
    <el-tab-pane :label="$t('customer_portal.Bills_to_pay')" name="unpaid" :lazy="true">
      <el-table
        ref="multipleTable"
        :data="unpaidInvoices"
        style="width: 100%"
        stripe
        empty-text="Aucune facture à payer"
        :empty-text="$t('customer_portal.No_invoices_available')"
        v-loading="loading"
        v-if="pageWidth>1024">
        <el-table-column type="expand">
          <template slot-scope="props" >
            <div class="p-20">
              <h4><i class="mdi mdi-credit-card-multiple"></i> {{$t('customer_portal.Payments')}}</h4>
              <div v-if="props.row.payments.length==0">
                <span class="fs-14 secondary-text">{{$t('customer_portal.Invoice_No_payment')}}</span>
              </div>
              <InvoicePaymentCard  v-for="payment in props.row.payments" :key="payment.id" :payment="payment"></InvoicePaymentCard>
            </div>
          </template>
        </el-table-column>
         <el-table-column
          width="45">
           <template slot-scope="props" >
            <el-checkbox :disabled="!canBePaidOrNot(props.row, props.$index)" v-model="props.row.selected" @change="onRowCheckboxChange()"></el-checkbox>
           </template>
        </el-table-column>
        <el-table-column
          property="invNumber"
          width="350"
          :label="$t('customer_portal.Invoice_number')">
          <template slot-scope="scope">
            <status-indicator class="mr-10" :negative="isLate(scope.row)" :positive="scope.row.paid==false && isLate(scopw.row) === false" pulse/>
            <el-link type="primary" :underline="false" @click="downloadInvoiceReport(scope.row)">{{scope.row.invNumber}} <i class="mdi mdi-download"></i></el-link>
            <span v-if="scope.row.files.length>0">
              <br>
              <span class="fs-14 secondary-text" style="padding-left:20px;">Pièce(s) jointe(s) : </span><br>
              <ul v-for="(f, index) in scope.row.files" :key="index" style="margin-top:0px;">
                <li class="fs-12"><el-link  :underline="false" @click="downloadAttachment(scope.row.id, f)">{{f.filename}} <i class="mdi mdi-attachment"></i></el-link></li>
              </ul>
            </span>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('customer_portal.Invoice_Date')"
          prop="date">
          <template slot-scope="scope">
            {{_moment(scope.row.date)}}
          </template>
        </el-table-column>
        <el-table-column
          property="due_date"
          :label="$t('customer_portal.Invoice_Due_date')">
          <template slot-scope="scope">
            <span v-if="scope.row.dueDate != null">{{_moment(scope.row.dueDate)}}</span>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('customer_portal.Invoice_Amount_due')">
          <template slot-scope="scope">
            {{$n(scope.row.balance.outstanding, 'currency',scope.row.currency.code)}}
          </template>
        </el-table-column>
        <el-table-column
          property="paid"
          :label="$t('customer_portal.Status')">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status.code=='PARTIALLY_PAID'" :type="getInvoiceTagType(scope.row)">{{$t("invoices.statuses."+scope.row.status.code)}}</el-tag>
            <el-tag v-else :type="getInvoiceTagType(scope.row)">{{$t("invoices.statuses.UNPAID")}}</el-tag>
          </template>
        </el-table-column>
      </el-table>
      <div v-else>
        <el-card style="text-align:center;" v-if="loading == true" v-loading="loading">
          <span v-if="unpaidInvoices.length==0 && loading == false" class="fs-14 secondary-text">{{$t('customer_portal.No_invoices_available')}}</span>
        </el-card>

        <el-card shadow="hover" v-for="(invoice, index) in unpaidInvoices" :key="invoice.id" style="color:#4a596a;margin-bottom:10px;" v-loading="loading">
            <div :style="getInvoiceHeight(invoice)">
              <div style="float:left;margin-right:20px;height:100%;">
                <el-checkbox @change="v=>selectInvoice({id:invoice.id, selected:v})" :value="invoice.selected" :disabled="!canBePaid(index)"></el-checkbox>
              </div>
              <div style="display:block;float:left;margin-bottom:20px;">
                <el-link type="primary" :underline="false" @click="downloadInvoiceReport(invoice)">
                  <strong>{{invoice.invNumber}}</strong><i class="mdi mdi-download"></i>
                </el-link><br>
                <div v-if="pageWidth<500">
                  <el-tag v-if="invoice.status.code=='PARTIALLY_PAID'" :type="getInvoiceTagType(invoice)" style="margin-top:10px;">{{$t("invoices.statuses."+invoice.status.code)}}</el-tag>
                  <el-tag v-else :type="getInvoiceTagType(invoice)">{{$t("invoices.statuses.UNPAID")}}</el-tag>
                </div>
                <span class="fs-14 secondary-text">{{$t('customer_portal.Invoice_Date_of_issue_colon')}} {{_moment(invoice.date)}}</span><br>
                <span class="fs-14 secondary-text">{{$t('customer_portal.Invoice_Due_date_colon')}} {{_moment(invoice.dueDate)}}</span><br>
                <span class="fs-14 secondary-text">{{$t('customer_portal.Invoice_Total_amount_colon')}} {{$n(invoice.total,'currency',invoice.currency.code)}}</span>
                <span class="hidden-md-and-up fs-14 secondary-text"><br>{{$t('customer_portal.Invoice_Amount_due_colon')}} {{$n(amountDue(invoice),'currency')}}</span>
                <span v-if="invoice.files.length>0">
                  <br>
                  <br>
                  <span class="fs-14 secondary-text" style="padding-left:20px;">Pièce(s) jointe(s) : </span><br>
                  <ul v-for="(f, index) in invoice.files" :key="index" style="margin-top:0px;margin-bottom:5px;">
                    <li class="fs-12"><el-link  :underline="false" @click="downloadAttachment(invoice.id, f)">{{f.filename}} <i class="mdi mdi-attachment"></i></el-link></li>
                  </ul>
                </span>
                <br v-else/>
                <el-button type="text" @click="showInvoiceDetail(invoice)">Voir les paiements</el-button>
              </div>
              <div v-if="pageWidth>=500" class="fs-14 secondary-text" style="float:right;text-align:right;">
                <span>{{$t('customer_portal.Invoice_Amount_due')}}</span><br>{{$n(amountDue(invoice),'currency', invoice.currency.code)}}<br>
                <el-tag v-if="invoice.status.code=='PARTIALLY_PAID'" :type="getInvoiceTagType(invoice)" style="margin-top:10px;">{{$t("invoices.statuses."+invoice.status.code)}}</el-tag>
              </div>
            </div>
            <div style="display:block;text-align:left;" v-if="selectedInvoiceId==invoice.id">
              <el-divider/>
              <h4><i class="mdi mdi-credit-card-multiple"></i> {{$t('customer_portal.Payments')}}</h4>
              <div v-if="invoice.payments.length==0">
                <span class="fs-14 secondary-text">{{$t('customer_portal.Invoice_No_payment')}}</span>
              </div>
              <InvoicePaymentCard  v-for="payment in invoice.payments" :key="payment.id" :payment="payment"></InvoicePaymentCard>
            </div>
        </el-card>
      </div>
      <div style="margin-top: 20px">
        <el-button @click="pay" :disabled="selectedInvoices.length==0">{{$t('customer_portal.Pay_online')}}</el-button>
        <el-button @click="toggleSelection()">{{$t('customer_portal.Unselect')}}</el-button>
        <!-- <div style="float:right;" v-if="showLink">
          <el-link type="primary" @click="showInvoices">{{$t('customer_portal.See_all_my_invoices')}}</el-link>
        </div> -->
      </div>
    </el-tab-pane>
    <el-tab-pane :label="$t('customer_portal.Invoice_history')" name="paid" :lazy="true">
      <el-table
        ref="multipleTable"
        :data="paidInvoices"
        stripe
        style="width: 100%"
        :empty-text="$t('customer_portal.No_historic_invoices_available')"
        v-loading="loading"
        v-if="pageWidth>1024">
        <el-table-column type="expand">
          <template slot-scope="props">
            <div class="p-20">
              <h4><i class="mdi mdi-credit-card-multiple"></i> {{$t('customer_portal.Payments')}}</h4>
              <div v-if="hasPayments(props.row)">
                <span class="fs-14 secondary-text">{{$t('customer_portal.Invoice_No_payment')}}</span>
              </div>
              <InvoicePaymentCard  v-for="payment in props.row.payments" :key="payment.id" :payment="payment" :currency="props.row.currency.code"></InvoicePaymentCard>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          property="inv_number"
          width="350"
          :label="$t('customer_portal.Invoice_number')">
          <template slot-scope="scope">
            <el-link type="primary" :underline="false" @click="downloadInvoiceReport(scope.row)">{{scope.row.invNumber}} <i class="mdi mdi-download"></i></el-link>
            <span v-if="scope.row.files.length>0">
              <br>
              <span class="fs-14 secondary-text" style="padding-left:20px;">Pièce(s) jointe(s) : </span><br>
              <ul v-for="(f, index) in scope.row.files" :key="index" style="margin-top:0px;">
                <li class="fs-12"><el-link  :underline="false" @click="downloadAttachment(scope.row.id, f)">{{f.filename}} <i class="mdi mdi-attachment"></i></el-link></li>
              </ul>
            </span>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('customer_portal.Invoice_Date')"
          prop="date">
          <template slot-scope="scope">
            {{_moment(scope.row.date)}}
          </template>
        </el-table-column>
        <el-table-column
          property="due_date"
          :label="$t('customer_portal.Invoice_Due_date')">
          <template slot-scope="scope">
            {{_moment(scope.row.dueDate)}}
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('customer_portal.Invoice_Amount_due')">
          <template slot-scope="scope">
            {{$n(scope.row.balance.outstanding, 'currency', scope.row.currency.code)}}
          </template>
        </el-table-column>
        <el-table-column
          property="paid"
          :label="$t('customer_portal.Status')">
          <template slot-scope="scope">
            <el-tag :type="getInvoiceTagType(scope.row)">{{$t("invoices.statuses."+scope.row.status.code)}}</el-tag>
          </template>
        </el-table-column>
      </el-table>
      <div v-else>
        <el-card style="text-align:center;" v-if="paidInvoices.length==0">
          <span class="fs-14 secondary-text">{{$t('customer_portal.No_historic_invoices_available')}}</span>
        </el-card>
        <el-card shadow="hover" v-for="(invoice, index) in paidInvoices" :key="invoice.id" style="color:#4a596a;margin-bottom:10px;">
            <div :style="getInvoiceHeight(invoice)">
              <div style="display:block;float:left;margin-bottom:20px;">
                <el-link type="primary" :underline="false" @click="downloadInvoiceReport(invoice)">
                  <strong>{{invoice.invNumber}}</strong><i class="mdi mdi-file-pdf"></i>
                </el-link><br>
                <div v-if="pageWidth<500">
                  <el-tag :type="getInvoiceTagType(invoice)" style="margin-top:10px;">{{$t("invoices.statuses."+invoice.status.code)}}</el-tag>
                </div>
                <span class="fs-14 secondary-text">{{$t('customer_portal.Invoice_Date_of_issue_colon')}} {{_moment(invoice.date)}}</span><br>
                <span class="fs-14 secondary-text">{{$t('customer_portal.Invoice_Due_date_colon')}} {{_moment(invoice.dueDate)}}</span><br>
                <span class="fs-14 secondary-text">{{$t('customer_portal.Invoice_Total_amount_colon')}} {{$n(invoice.total,'currency', invoice.currency.code)}}</span>
                <span class="hidden-md-and-up fs-14 secondary-text"><br>{{$t('customer_portal.Invoice_Amount_due_colon')}} {{$n(amountDue(invoice),'currency', invoice.currency.code)}}</span>
                <span v-if="invoice.files.length>0">
                  <br>
                  <br>
                  <span class="fs-14 secondary-text" style="padding-left:20px;">Pièce(s) jointe(s) : </span><br>
                  <ul v-for="(f, index) in invoice.files" :key="index" style="margin-top:0px;margin-bottom:5px;">
                    <li class="fs-12"><el-link  :underline="false" @click="downloadAttachment(invoice.id, f)">{{f.filename}} <i class="mdi mdi-attachment"></i></el-link></li>
                  </ul>
                </span>
                <br v-else/>
                <el-button type="text" @click="showInvoiceDetail(invoice)">Voir les paiements</el-button>
              </div>
              <div v-if="pageWidth>=500" class="fs-14 secondary-text" style="float:right;text-align:right;">
                <span>{{$t('customer_portal.Invoice_Amount_due')}}</span><br>{{$n(amountDue(invoice),'currency', invoice.currency.code)}}<br>
                <el-tag v-if="invoice.status.code=='PARTIALLY_PAID'" :type="getInvoiceTagType(invoice)" style="margin-top:10px;">{{$t("invoices.statuses."+invoice.status.code)}}</el-tag>
              </div>
            </div>
            <div style="display:block;text-align:left;" v-if="selectedInvoiceId==invoice.id">
              <el-divider/>
              <h4><i class="mdi mdi-credit-card-multiple"></i> {{$t('customer_portal.Payments')}}</h4>
              <div v-if="invoice.payments.length==0">
                <span class="fs-14 secondary-text">{{$t('customer_portal.Invoice_No_payment')}}</span>
              </div>
              <InvoicePaymentCard  v-for="payment in invoice.payments" :key="payment.id" :payment="payment" :currency="invoice.currency.code"></InvoicePaymentCard>
            </div>
        </el-card>
      </div>
    </el-tab-pane>
    <el-tab-pane :label="$t('customer_portal.CreditNotesTitle')" name="credit" :lazy="true">
        <customerPortalCreditNotesViewer :customerId="customerId"></customerPortalCreditNotesViewer>
    </el-tab-pane>
  </el-tabs>



    <ProcessPaymentModal :portausCompanyId="portausCompanyId" :visible="processPaymentVisible" :customerId="customerId" :invoices="selectedInvoices" @close="closePaymentDialog" @paid="invoicesPaid"></ProcessPaymentModal>


  </div>
</template>
<script>
import moment from 'moment-timezone'
import { mapActions, mapState, mapGetters } from 'vuex';
import invoiceAPI from '@/services/API/invoice';
import customerPortalCreditNotesViewer from '@/components/creditNote/customer-portal-credit-notes-viewer.vue'
import ProcessPaymentModal from '@/components/Process-payment-modal.vue'
import { EventBus } from '@/core/event-bus'
import InvoicePaymentCard from '@/components/invoice/invoice-payment-card-v2.vue'
import dayJs from 'dayjs';
import axios from 'axios'

export default {
  name: 'Customer-portal-document-viewer',
	props: {
    portal : Boolean,
    customerId : Number,
    customer: {
      type: Object
    },
	},
  data() {
    return {
      activeName : 'unpaid',
      // invoices : [],
      processPaymentVisible : false,
      pageWidth : 0,
			pageHeight : 0,
      selectedInvoiceId : null,

      params : {paging:'no', orderBy:"date",unpaid:true,statusCode:['SENT','PARTIALLY_PAID','PAID'], direction:'DESC', detailed:true }
      // params : {unpaid:true, paging:'no', statusCode:['SENT','PARTIALLY_PAID'], orderBy:"date", direction:'ASC' }
    };
  },
  watch:{
    customerId : function(val){
      this.fetchCustomerInvoices(this.params);
      this.fetchCustomerInfos(val);
    }
  },
	methods: {
    onRowCheckboxChange () {
      const selectedInvoices = _.filter(this.unpaidInvoices, inv => inv.selected);
      this.setSelectedInvoices(selectedInvoices);
    },
    getInvoiceHeight(invoice){
      let height = 100;
      if(invoice.files.length>0){
        height+=35;
        height+=30*invoice.files.length;
      }
      // console.log("height : ", height);
      return "height:"+height+"px;";
    },
    downloadAttachment(invoiceId, file){
      // console.log(invoiceId, file);
      axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/invoices/"+invoiceId+"/files/"+file.id,{responseType: 'arraybuffer'})
  				.then(response=>{
            // console.log("response : ", response);
            // console.log("headers : ", response.headers);
            var headers = response.headers;
            var blob = new Blob([response.data],{type:headers['content-type']});
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = file.filename;
            link.click();
            // this.loading=false;
  				});
    },
    showInvoiceDetail(invoice){
      this.selectedInvoiceId = this.selectedInvoiceId==invoice.id?null:invoice.id;
    },
    closePaymentDialog(){
      this.processPaymentVisible=false;
      this.clearSelectedInvoices();
      this.toggleSelection();
    },
    // selectInvoice(invoice){
    //   let index = _.findIndex(this.selectedInvoices, i=>{return i.id==invoice.id})
    //   if(index!=-1){
    //     this.selectedInvoices.splice(index,1);
    //   }else{
    //     this.selectedInvoices.push(invoice);
    //   }
    // },
    __resizeHanlder: _.throttle(function (e) {
			this.setPageWidth();
		}, 700),
    showInvoices(){
      var index='/customers/invoices?'+this.$route.query.token;
      this.$router.push(index);
    },
    invoicesPaid(invoicesPaid){
      this.processPaymentVisible=false;
      this.toggleSelection();
      this.fetchCustomerInvoices(this.params);
      this.fetchCustomerInfos(this.customerId);
    },
    _moment(datetime, format='LL'){
      moment.locale(this.$i18n.locale);
      return moment(datetime).format(format);
    },
		toggleSelection(rows) {
      _.forEach(this.unpaidInvoices, invoice=>{
        invoice.selected = false;
      });
      this.onRowCheckboxChange();
    },
    canBePaidOrNot(row, index){
      return this.canBePaid(index);
    },
    calculateAmountDue(invoice){
      let amountDue = invoice.total;
      _.forEach(invoice.payments, payment=>{
        amountDue-=payment.invoice_payment.amount;
      })
      return amountDue
    },
		pay(){
			this.processPaymentVisible=true;
		},
    payInvoices(param){
      this.selectedInvoices = [];
      _.forEach(this.invoices, (invoice, index)=>{
        if(this.canBePaid(index)){
          this.selectedInvoices.push(invoice);
        }
      })
      if(this.selectedInvoices.length==0){
        this.$message({
          message: 'Aucune facture ne peut être payée en ligne.',
          type: 'warning'
        });
      }else{
        this.pay();
      }
    },
		setPageWidth() {
			this.pageWidth = document.getElementById('page-panel').offsetWidth;
			this.pageHeight = document.getElementById('page-panel').offsetHeight;
		},
    ...mapActions('invoices',['downloadInvoiceReport']),
    ...mapActions('customerInvoices',['fetchCustomerInvoices','fetchCustomerInfos','setCustomerId','setSelectedInvoices','selectInvoice','clearSelectedInvoices']),
    ...mapGetters('customerInvoices',['isSelected'])
	},
  components : {
    ProcessPaymentModal,
    InvoicePaymentCard,
    customerPortalCreditNotesViewer
  },
	computed: {
   portausCompanyId() {
    return _.get(_.head(this.selectedInvoices), 'portausCompany.id', null);
   },
   ...mapGetters('invoices',['getInvoiceTagType']),
   ...mapState('customerInvoices',['invoices','loading','selectedInvoices', 'loadingStats']),
   ...mapGetters('customerInvoices',['canBePaid','amountDue','isLate', 'paidInvoices','unpaidInvoices', 'hasPayments'])

	},
  mounted(){
    if(this.customerId){
      this.setCustomerId(this.customerId);
      this.fetchCustomerInvoices(this.params);
      this.fetchCustomerInfos(this.customerId);
      EventBus.$on('pay-invoices', this.payInvoices);
    }
    this.setPageWidth()
  }
}
</script>
<style lang="scss" scoped>




</style>
